import { isPhone } from '../utils/base-init.js'
import { _query } from '../utils/query.js'
import detectMobileWidth from '../utils/detectMobileWidth.js'

export async function showSeatLength () {
  // const seatLength = $('#select-tickets-active-tickets').find('.sy-cart-table-tr')
  //   .length

  try {
    if (Object.keys(window.selectedSeats).length !== 0 && window.selectedSeats.constructor === Object) {
      const seatLength = Object.keys(window.selectedSeats).length
      const icon = $('#select-tickets-tag').find('.syicon')
      const seatText = window.seatingChartVars.seatText
      const seatsText = window.seatingChartVars.seatsText

      if (!detectMobileWidth()) {
        $('.ticketInfo__activeContainer').fadeIn()
        // $('#select-tickets-active-content').fadeIn()
      }

      _query('.ticketInfo__activeContainer').classList.add('SeatsPopup--Active')

      $('.ticketInfo__activeContainer .select-tickets-active-stack-header').fadeIn()
      $('.share-seat-trigger-mobile').removeClass('disabled')
      icon.fadeIn()

      if (seatLength > 1) {
        $('#seat-length').html(seatLength + ' ' + seatsText)
        if (seatLength > 3) {
          $('.hide-more-seat').show()
        } else {
          $('.hide-more-seat').hide()
        }
      } else if (seatLength == 1) {
        $('#seat-length').html(seatLength + ' ' + seatText)
      }
      // console.info(`not empty: ${seatLength}`)

    } else if (Object.keys(window.selectedSeats).length === 0 && window.selectedSeats.constructor === Object) {
      const seatLength = Object.keys(window.selectedSeats).length
      const icon = $('#select-tickets-tag').find('.syicon')
      // const seatText = window.seatingChartVars.seatText
      const seatsText = window.seatingChartVars.seatsText

      _query('.ticketInfo__activeContainer').classList.remove('SeatsPopup--Active')
      if (!detectMobileWidth()) $('.ticketInfo__activeContainer').fadeOut()
      icon.fadeOut()
      $('.select-tickets-active-stack-header').fadeOut()
      $('#seat-length').html(seatLength + ' ' + seatsText)
      $('.share-seat-trigger-mobile').addClass('disabled')
      $('#select-tickets-active-content').fadeOut()
    }
  } catch (e) {
    console.debug(`showSeatLength error by ${e}`)
  }
  // return Promise.resolve()
}

export default showSeatLength
